import React, {useState} from 'react';
import './Editable.css';
import 'react-phone-number-input/style.css'
import '../../App/Styles.css'
import {Editable, EditableProps} from "./Editable";
import PhoneInput from "react-phone-number-input";
import {useEditable} from "./EditableContext";
import {EmailOrPhoneLocation, space} from "../../provider_api";
import {VerifyContactMethodOverlay} from "../VerifyContactMethodOverlay";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {isBusinessPhoneVerified} from "../../util/BusinessUtil";
import ContactMethodType = space.kenko.proto.ContactMethodType;

type Props<EnclosingType extends object> = EditableProps<EnclosingType, string> & {
  location: EmailOrPhoneLocation,
}

export const EditableVerifiedPhoneInputField = <EnclosingType extends object>(props: Props<EnclosingType>) => {

  const {editing, mode, value, setValue} = useEditable(props);

  const {business, provider} = useProviderProfile();
  
  // If they clicked the verify button!!
  const [isVerifying, setIsVerifying] = useState(false);

  let isVerified = false;
  switch(props.location) {
    case EmailOrPhoneLocation.PROVIDER:
      isVerified = isBusinessPhoneVerified(provider, value);
      break;
    case EmailOrPhoneLocation.BUSINESS:
      isVerified = isBusinessPhoneVerified(business, value);
      break;
  }
  if (editing) {
    return <Editable {...props}>
      <PhoneInput
          placeholder="Enter phone number"
          defaultCountry={'US'}
          value={value ?? ''}
          onChange={v => {
            setValue(v as string);
          }}/>
    </Editable>

  } else {

    return <Editable {...props}>
      <div className={'EditableNotEditing'}>
        {value} {value && (isVerified ? '(verified)' : <>(not verified) [<a
          style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => setIsVerifying(true)}>verify
        now</a>]</>)}
      </div>

      {isVerifying && <VerifyContactMethodOverlay
          type={ContactMethodType.MOBILE_PHONE}
          location={props.location} value={value}
          onDone={() => {setIsVerifying(false)}}/>}

    </Editable>
  }

}